// extracted by mini-css-extract-plugin
export var alignCenter = "_72-d";
export var bannerShown = "_72-6";
export var buttonContent = "_72-0";
export var cardList = "_72-1";
export var centerContent = "_72-2";
export var chevron = "_72-3";
export var closePanelButton = "_72-k";
export var conversationContextContainer = "_72-l";
export var conversationDetailContainer = "_72-4";
export var detailWrapper = "_72-7";
export var dropdownButton = "_72-e";
export var dropdownTitle = "_72-9";
export var fullHeight = "_72-5";
export var hidden = "_72-a";
export var icon = "_72-b";
export var mergeSuggestionWrapper = "_72-m";
export var panel = "_72-i";
export var portalButtonsWrapper = "_72-c";
export var right = "_72-j";
export var tableSummaryContainer = "_72-8";
export var tableSummaryHeader = "_72-g";
export var threeDotsButton = "_72-f";
export var wide = "_72-h";